import {Text, Section, Box} from '@primer/react-brand/esm'

import type {PlatformsSectionContent} from '../../content'
import {LogoTiles} from '../../_components/LogoTiles/LogoTiles'

type Props = {
  contentfulContent: PlatformsSectionContent
}

export function PlatformsSection({contentfulContent}: Props) {
  const sectionId = contentfulContent.section.fields.htmlId
  const heading = contentfulContent.heading?.fields.heading

  return (
    <Section id={sectionId}>
      {heading ? (
        <Box paddingBlockEnd="normal" style={{textAlign: 'center'}}>
          <Text variant="muted">{heading}</Text>
        </Box>
      ) : null}

      <LogoTiles location="cta" />
    </Section>
  )
}
